<span [class]="{ scheduler: true }" class="scheduler align-items-center">
  @switch (cell?.subtype) {
    @case ("time") {
      @for (value of getCellValueAsArray(cell?.value); track i; let i = $index) {
        <span class="mb-1 d-flex align-items-center px-2 time-input-wrapper">
          <span>
            {{ cell?.data[i].action.split("#")[0] === "start" ? "Start Time" : "Stop Time" }}
          </span>
          <span class="ms-2">
            @switch (cell?.data[i].action.split("#")[0]) {
              @case ("start") {
                <fa-icon class="me-2 position-relative text-success time-arrow" [icon]="faArrowUp"></fa-icon>
              }
              @case ("stop") {
                <fa-icon class="me-2 position-relative text-primary time-arrow" [icon]="faArrowDown"></fa-icon>
              }
            }
          </span>
          <mat-form-field class="time-input-field">
            <input
              matInput
              type="text"
              [ngxMatTimepicker]="picker"
              [value]="cell?.value[i]"
              [disabled]="cell?.disabled || (!handlers.isRowInEditMode(rowIndex) && handlers.isGroupSchedulerTable())"
              [id]="handlers.buildElementId('time-picker-input', rowIndex, colIndex, i)"
            />
            <ngx-mat-timepicker
              #picker
              (timeSet)="onCellChange($event, cell?.data[i], columnTitle, row!, null)"
            ></ngx-mat-timepicker>
            <span class="time-zone"> UTC{{ cell?.offset }} </span>
          </mat-form-field>
        </span>
      }
    }

    @case ("checkbox") {
      @if (isArray(cell?.data)) {
        @for (d of cell?.data; track $index; let i = $index) {
          <span>
            <input
              [id]="handlers.buildElementId('scheduler-day-checkbox', rowIndex, colIndex, i)"
              type="checkbox"
              placement="right"
              [disabled]="cell?.disabled"
              [(ngModel)]="cell!.value[i]"
              (change)="onCellChange($event, cell?.data[i], columnTitle, row!, null)"
            />
          </span>
        }
      }
    }
    @case ("weekDays") {
      @for (d of cell?.data; track j; let j = $index) {
        <div class="d-flex justify-content-center align-items-center weekDaysContainer px-2">
          @for (day of weekDays; track i; let i = $index) {
            <div class="days d-flex flex-column align-items-center">
              @if (j === 0) {
                <span>{{ daysOfWeek[i] }}</span>
              }
              <span>
                <input
                  [id]="handlers.buildElementId('weekday-checkbox', rowIndex, colIndex, i)"
                  type="checkbox"
                  placement="right"
                  [disabled]="
                    cell?.disabled || (!handlers.isRowInEditMode(rowIndex) && handlers.isGroupSchedulerTable())
                  "
                  [(ngModel)]="cell!.value[j][i]"
                  (change)="
                    onCellChange($event, cell?.data[j], columnTitle, row!, {
                      dayIndex: i,
                    })
                  "
                />
              </span>
            </div>
          }
        </div>
      }
    }

    @case ("toggle") {
      @for (d of cell?.data; track d.action; let i = $index) {
        <span class="enable-cell-container">
          <div class="enable-cell">
            <label
              class="switch position-relative d-inline-block mb-0"
              [tooltip]="
                columnTitle === 'enabled'
                  ? cell?.permission && d.enabled
                    ? 'Click to disable schedule'
                    : 'Click to enable schedule'
                  : columnTitle === 'dbs_enabled'
                    ? cell?.permission && d.dbs_enabled
                      ? 'You cannot opt out of database scheduling, please reach out to PCS and follow the exemption process'
                      : 'Click to include/exclude RDS databases from this schedule'
                    : ''
              "
              placement="left"
              container="body"
            >
              <input
                hidden="true"
                type="checkbox"
                [disabled]="
                  (columnTitle === 'enabled'
                    ? cell?.disabled || (d.enabled && !cell?.permission && d.action.split('#')[0] === 'stop')
                    : columnTitle === 'dbs_enabled'
                      ? cell?.disabled || !cell?.permission
                      : cell?.disabled) ||
                  (!handlers.isRowInEditMode(rowIndex) && handlers.isGroupSchedulerTable())
                "
                [(ngModel)]="cell!.value[i]"
                (change)="onCellChange($event, cell?.data[i], columnTitle, row!, null)"
              />
              <span class="slider round"></span>
            </label>
          </div>
        </span>
      }
    }
    @case ("state") {
      <div
        class="state-cell d-flex justify-content-center align-items-center"
        [class]="handlers.getStateClass(getCellValueAsString(cell?.value))"
      >
        <span>{{ cell?.value }}</span>
      </div>
    }
    @case ("action") {
      <div class="d-flex justify-content-center align-items-center">
        @if (handlers.getButtonConfig(getCellValueAsString(cell?.value)); as btnConfig) {
          <button
            [id]="handlers.buildElementId('state-action-button', rowIndex, colIndex)"
            [attr.aria-label]="btnConfig.text + ' instance'"
            class="action-btn"
            [class]="btnConfig.cssClass"
            [disabled]="btnConfig.disabled"
            (click)="onCellChange($event, cell?.data, columnTitle, row!, null, btnConfig.text)"
          >
            <span class="btn-label">{{ btnConfig.text }}</span>
          </button>
        }
      </div>
    }

    @case ("update") {
      <div class="d-flex">
        @if (!handlers.isRowInEditMode(rowIndex)) {
          <button
            [id]="handlers.buildElementId('edit-row-button', rowIndex, colIndex)"
            (click)="handlers.toggleEditMode(rowIndex)"
            class="btn btn-action p-1"
          >
            <app-vficon
              size="20px"
              class="position-relative"
              color="grey"
              iconPack="source-system-icons"
              iconName="edit"
              tooltip="Edit"
            />
          </button>
          <button
            [id]="handlers.buildElementId('delete-row-button', rowIndex, colIndex)"
            (click)="handlers.deleteRow(row!)"
            class="btn btn-action p-1"
          >
            <app-vficon
              size="20px"
              class="position-relative"
              color="red"
              iconPack="source-system-icons"
              iconName="delete"
              tooltip="Delete"
            />
          </button>
        } @else {
          <button
            [id]="handlers.buildElementId('save-row-button', rowIndex, colIndex)"
            (click)="handlers.saveRowChanges(row!, rowIndex)"
            class="btn btn-action p-1"
          >
            <app-vficon
              size="20px"
              class="position-relative"
              color="green"
              iconPack="source-system-icons"
              iconName="tick-circle"
              tooltip="Save changes"
            />
          </button>
          <button
            [id]="handlers.buildElementId('cancel-row-button', rowIndex, colIndex)"
            (click)="handlers.cancelRowEdit(rowIndex)"
            class="btn btn-action p-1"
          >
            <app-vficon size="20px" class="position-relative" color="red" iconName="cancel" tooltip="Cancel" />
          </button>
        }
      </div>
    }
    @case ("button") {
      <div class="d-flex">
        <button class="navigate-btn" (click)="onCellChange($event, cell?.data, columnTitle, row!, null)">
          <span class="btn-label">{{ cell?.value }}</span>
        </button>
      </div>
    }

    @case ("exclude") {
      <div class="d-flex justify-content-center flex-column exclusions">
        @for (exclusionType of exclusionTypes; track exclusionType.title) {
          <h5 [class]="exclusionType.colorClass">{{ exclusionType.title }}</h5>
          @for (e of exclusionType.getFn(cell?.data); track eidx; let eidx = $index) {
            <div class="card exclusion-card">
              <div class="card-header" [class]="exclusionType.type === 'stop' ? 'stop-header' : 'start-header'">
                Exclusion {{ eidx + 1 }} - {{ exclusionType.title.split(" ")[0] }}
              </div>
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    [tooltip]="
                      cell?.permission
                        ? 'AWS tags, these are joined by OR'
                        : 'You cannot opt out of scheduler, please reach out to PCS and follow the exemption process'
                    "
                    [disabled]="cell?.disabled || !cell?.permission"
                    [pattern]="cell?.pattern"
                    [placeholder]="cell?.placeholder + ' key'"
                    [(ngModel)]="e.key"
                    (change)="
                      onCellChange($event, cell?.data[exclusionType.index], columnTitle, row!, {
                        action: 'key',
                        index: eidx,
                      })
                    "
                  />
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    [tooltip]="
                      cell?.permission
                        ? 'AWS tags, these are joined by OR'
                        : 'You cannot opt out of scheduler, please reach out to PCS and follow the exemption process'
                    "
                    [disabled]="cell?.disabled || !cell?.permission"
                    [pattern]="cell?.pattern"
                    [placeholder]="cell?.placeholder + ' value'"
                    [(ngModel)]="e.value"
                    (change)="
                      onCellChange($event, cell?.data[exclusionType.index], columnTitle, row!, {
                        action: 'value',
                        index: eidx,
                      })
                    "
                  />
                  <button
                    type="button"
                    class="btn btn-sm delete-btn"
                    [tooltip]="
                      cell?.permission
                        ? 'Delete'
                        : 'You cannot opt out of scheduler, please reach out to PCS and follow the exemption process'
                    "
                    [disabled]="cell?.disabled || !cell?.permission"
                    (click)="
                      onCellChange($event, cell?.data[exclusionType.index], columnTitle, row!, {
                        action: 'delete',
                        index: eidx,
                      })
                    "
                  >
                    X
                  </button>
                </div>
              </div>
            </div>
          }
          <button
            type="button"
            class="btn new-btn"
            [class]="exclusionType.type === 'stop' ? 'stop-btn' : 'start-btn'"
            [tooltip]="
              cell?.permission
                ? exclusionType.tooltip
                : 'You cannot opt out of scheduler, please reach out to PCS and follow the exemption process'
            "
            [disabled]="cell?.disabled || !cell?.permission"
            (click)="handlers.handleExclusionAdd(cell?.data, exclusionType.type)"
          >
            {{ exclusionType.buttonText }}
          </button>
        }
      </div>
    }
  }
</span>
